<template>
  <div>
    <div>
      <p class="icon-jujue closeBtn" @click="routerBack"></p>
    </div>
    <div class="content_box">
      <el-row style="margin:5px 0">
        <el-button size="mini" class="btn" type="primary" @click="stinvUrl"
          v-if="detailForm.stinvLink">STINV链接</el-button>
        <el-button v-if="closeBtn" v-acl="QUALITY_DEFECT_CLOSE" size="mini" class="btn" type="primary"
          @click="closeQualityDefect">结案</el-button>
      </el-row>
      <div class="within_box">
        <div class="title_box">
          <p class="line"></p>
          <p class="title">Case Detail</p>
        </div>
        <div class="form_box">
          <el-form :model="detailForm" ref="detailForm" :rules="rules" label-width="100px">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="主动报废编号" prop="sroCode">
                  <el-input v-model="detailForm.sroCode" disabled style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="报废启动日期" prop="startDate">
                  <el-date-picker v-model="detailForm.startDate" type="date" disabled value-format="yyyy-MM-dd"
                    placeholder="请选择" style="width:100%"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="报废项目简介" prop="projectSummary">
                  <el-input v-model="detailForm.projectSummary" style="width:100%" disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="已结案" prop="isClosed">
                  <el-select v-model="detailForm.isClosed" disabled placeholder="请选择" style="width:100%">
                    <el-option :key="index" v-for="(item, index) in isClosedLists" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="SR等级" prop="grade">
                  <el-select disabled v-model="detailForm.grade" clearable placeholder="请选择" style="width:100%">
                    <el-option :key="index" v-for="(item, index) in srGradeLists" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="发起人" prop="creator">
                  <el-input v-model="detailForm.creator" disabled style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="状态" prop="status">
                  <ic-select disabled table="TT_QUALITY_DEFECT" field="STATUS" v-model="detailForm.status"
                    style="width:100%"></ic-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="原因" prop="reason">
                  <el-input disabled v-model="detailForm.reason" type="textarea" maxlength="1000" show-word-limit
                    :autosize="{ minRows: 4, maxRows: 6 }" placeholder="请输入内容"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="备注" prop="remarks">
                  <el-input disabled v-model="detailForm.remarks" type="textarea" maxlength="1000" show-word-limit
                    :autosize="{ minRows: 4, maxRows: 6 }" placeholder="请输入内容"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="是否下发成功" prop="isIssued">
                  <el-input v-model="detailForm.isIssued" disabled style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="下发时间" prop="issueDate">
                  <el-input v-model="detailForm.issueDate" disabled style="width:100%"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
      <div class="tab_box">
        <el-tabs type="border-card" v-model="activeName">
          <el-tab-pane label="产品明细" name="tab1" class="setLength">
            <!-- <el-row style="margin-bottom:5px">
              <el-button size="mini" class="btn" type="primary" @click="onAdd('Save')">新增</el-button>
              <el-button size="mini" class="btn" type="danger" @click="onDel('Save')">删除</el-button>
              <el-button size="mini" class="btn" type="primary" @click="onCopy('Save')">复制行</el-button>
            </el-row> -->
            <ux-grid ref="plxTable1" :data="tabData1" @selection-change="selectionChange" keep-source max-height="500"
              show-overflow="tooltip" highlight-current-row>
              <ux-table-column align="center" title="序号" type="index" width="60" />
              <ux-table-column align="center" title="产品编号" field="eightBitCode" min-width="100"></ux-table-column>
              <ux-table-column align="center" title="产品名称" field="eightBitCodeName" min-width="100"></ux-table-column>
              <ux-table-column align="center" title="结算单位名称" field="supplierName" min-width="120"></ux-table-column>
              <ux-table-column align="center" title="Facility名称" field="facilityName" min-width="120"></ux-table-column>
              <ux-table-column align="center" title="包装类型" field="packType" min-width="120">
                <template v-slot="scope">
                  {{ scope.row.packType | ic('TT_QUALITY_DEFECT', 'PACK_TYPE') }}
                </template>
              </ux-table-column>
              <ux-table-column align="center" title="生产日期" field="madeDate" min-width="120"></ux-table-column>
              <ux-table-column align="center" title="批次号" field="batchNo" min-width="120"></ux-table-column>
              <ux-table-column align="center" title="DCs" field="dcCode" min-width="120">
                <template v-slot="scope">
                  <div class="newDcs">
                    {{ scope.row.dcCode | dcsFilter }}
                  </div>
                </template>
              </ux-table-column>
              <ux-table-column align="center" title="Markets" field="marketName" min-width="120">
                <template v-slot="scope">
                  <div class="newDcs">
                    {{ scope.row.marketName | dcsFilter }}
                  </div>
                </template>
              </ux-table-column>
              <ux-table-column align="center" title="报废范围" field="disposalScope" min-width="120">
                <template v-slot="scope">
                  {{ scope.row.disposalScope | ic('TT_QUALITY_DEFECT', 'DISPOSAL_SCOPE') }}
                </template>
              </ux-table-column>
              <ux-table-column align="center" title="餐厅报废数量(箱)" field="storeDisposalQty"
                min-width="150"></ux-table-column>
              <ux-table-column align="center" title="DC报废数量(箱)" field="dcDisposalQty" min-width="120"></ux-table-column>
              <ux-table-column align="center" title="报废数量(箱)" field="disposalQty" min-width="120"></ux-table-column>
              <ux-table-column align="center" title="处理结果" field="handlingResult" min-width="120">
                <template v-slot="scope">
                  {{ scope.row.handlingResult | ic('TT_QUALITY_DEFECT', 'HANDLING_RESULT') }}
                </template>
              </ux-table-column>
            </ux-grid>
          </el-tab-pane>
          <el-tab-pane label="门店报废统计" name="tab2">
            <!-- <el-row style="margin-bottom:5px">
              <el-button size="mini" class="btn" type="primary" @click="onAdd('Save')">新增</el-button>
              <el-button size="mini" class="btn" type="danger" @click="onDel('Save')">删除</el-button>
              <el-button size="mini" class="btn" type="primary" @click="onCopy('Save')">复制行</el-button>
            </el-row> -->
            <el-table ref="plxTable1" :data="tabData2" @selection-change="selectionChange" keep-source max-height="500"
              show-overflow="tooltip" highlight-current-row>
              <el-table-column align="center" type="checkbox" width="80" />
              <el-table-column align="center" label="序号" type="index" width="60" />
              <el-table-column align="center" label="产品编号" prop="eightBitCode"></el-table-column>
              <el-table-column align="center" label="产品名称" prop="eightBitCodeName"></el-table-column>
              <el-table-column align="center" label="生产日期" prop="madeDate"></el-table-column>
              <el-table-column align="center" label="批次号" prop="batchNo"></el-table-column>
              <el-table-column align="center" label="DC" prop="dcCode">
              </el-table-column>
              <el-table-column align="center" label="涉及Markets" prop="marketName"></el-table-column>
              <el-table-column align="center" label="报废数量(箱)" prop="disposalQty"></el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="附件上传" name="tab3">
            <!-- <el-row style="margin-bottom:5px">
              <el-button size="mini" class="btn" type="primary" @click="onUpload">上传</el-button>
            </el-row> -->
            <el-table ref="plxTable2" :data="tabData3" max-height="500" border highlight-current-row>
              <!-- <el-table-column align="center" label="操作" width="80">
                <template slot-scope="scope">
                  <el-button type="text" @click="delFile(scope.row, scope.$index)">删除</el-button>
                </template>
              </el-table-column> -->
              <el-table-column align="center" label="附件名称" prop="documentName" show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-button type="text" @click="onDownload(scope.row, scope.$index)">{{ scope.row.documentName
                  }}</el-button>
                </template>
              </el-table-column>
              <el-table-column align="center" label="附件描述" prop="docComments" show-overflow-tooltip></el-table-column>
              <el-table-column align="center" label="上传人" prop="userName" show-overflow-tooltip></el-table-column>
              <el-table-column align="center" label="上传时间" prop="createDate" show-overflow-tooltip></el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="操作日志" name="tab4">
            <el-table ref="plxTable3" :data="tabData4" max-height="500" highlight-current-row>
              <el-table-column align="center" label="操作时间" prop="createDate"></el-table-column>
              <el-table-column align="center" label="操作人" prop="operatorName"></el-table-column>
              <el-table-column align="center" label="操作描述" prop="action"></el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <!-- <el-dialog title="产品明细" :visible.sync="dialogEditVisible" width="80%" @close="onCancel">
      <el-form :model="editForm" ref="editForm">
        <el-table :data="editForm.editData" ref="editDataRef" border highlight-current-row class="stockRecovery_table">
          <el-table-column show-overflow-tooltip prop="eightBitCode" label="产品编号"></el-table-column>
          <el-table-column show-overflow-tooltip prop="eightBitCodeName" label="产品名称"></el-table-column>
          <el-table-column show-overflow-tooltip prop="supplierName" label="结算单位名称"></el-table-column>
          <el-table-column show-overflow-tooltip prop="facilityName" label="Facility名称"></el-table-column>
          <el-table-column show-overflow-tooltip prop="facilityName" label="包装类型"></el-table-column>
          <el-table-column show-overflow-tooltip prop="facilityName" label="生产日期"></el-table-column>
          <el-table-column show-overflow-tooltip prop="batchNo" label="批次号" :render-header="renderHeader">
            <template slot-scope="scope">
              <el-button type="text" @click="clickBatch(scope.row)">列表维护</el-button>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="regoins" label="Regions">
            <template slot-scope="scope">
              <el-form-item :prop="`editData.${scope.$index}.regoins`">
                <el-input v-model="scope.row.regoins"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column sortable prop="recoveryScope" label="报废范围" :render-header="renderHeader">
            <template slot-scope="scope">
              <el-form-item :prop="`editData.${scope.$index}.recoveryScope`">
                <ic-select table="TT_QSPI_STOCK_REC_ITEM" field="RECOVERY_SCOPE" @change="recoveryScopeChange(scope.row,$event)" v-model="scope.row.recoveryScope" style="width:100%"></ic-select>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column sortable prop="restaurantRecoveryQty" label="餐厅回收数量(箱)">
            <template slot-scope="scope">
              <el-form-item :prop="`editData.${scope.$index}.restaurantRecoveryQty`" :rules="restaurantRecoveryQtyRules(scope.$index,scope.row)">
                <el-input v-model="scope.row.restaurantRecoveryQty" @change="restaurantRecoveryQtyChange(scope.row,$event)" :disabled="scope.row.recoveryScope==='DC'"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column sortable prop="dcRecoveryQty" label="DC回收数量(箱)">
            <template slot-scope="scope">
              <el-form-item :prop="`editData.${scope.$index}.dcRecoveryQty`" :rules="dcRecoveryQtyRules(scope.$index,scope.row)">
                <el-input v-model="scope.row.dcRecoveryQty" @change="dcRecoveryQtyChange(scope.row,$event)" :disabled="scope.row.recoveryScope==='Restaurant'"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column sortable prop="recoveryQty" label="报废数量(箱)"></el-table-column>
          <el-table-column sortable prop="handlingResult" label="处理结果" :render-header="renderHeader">
            <template slot-scope="scope">
              <el-form-item :prop="`editData.${scope.$index}.handlingResult`">
                <ic-select table="TT_QSPI_STOCK_REC_ITEM" field="HANDLING_RESULT" multiple @change="handlingResultChange($event,scope.$index,editForm.editData)" v-model="scope.row.handlingResult" style="width:100%"></ic-select>
              </el-form-item>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <el-row type="flex" justify="center" style="margin-top:10px;">
        <el-button type="primary" @click="onCancel">取消</el-button>
        <el-button type="primary" @click="onConfirm">确认</el-button>
      </el-row>
    </el-dialog>
    <el-dialog title="附件上传" :visible.sync="dialogUploadVisible" width="50%" @close="onClose">
      <el-form :model="uploadForm" ref="uploadForm" :rules="rules" label-width="100px">
        <el-row :gutter="20">
          <el-col :span="20">
            <el-form-item label="附件描述" prop="docComments">
              <el-input v-model="scope.row.docComments"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="20">
            <el-form-item label="附件名称" prop="fileName">
              <el-input v-model="uploadForm.fileName" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-upload ref="upload" :headers="header" :action="uploadUrl" :on-success="uploadSuccess" :on-change="handleChange" :before-upload="beforeUpload" :file-list="fileList" :limit="1" :auto-upload="false" :show-file-list="false">
              <el-button size="small" type="primary">选取文件</el-button>
            </el-upload>
          </el-col>
        </el-row>
        <el-row type="flex" justify="center">
          <el-button size="small" type="primary" @click="submitUpload">上传</el-button>
          <el-button size="small" type="primary" @click="onCloseFileDialog">关闭</el-button>
        </el-row>
      </el-form>
    </el-dialog> -->


    <!-- <el-dialog title="批次号维护" :visible.sync="batchVisible" width="40%" @close="onCancel1">
      <el-form :model="editForm" ref="editForm">
        <el-row type="flex" justify="center">
          <el-col :span="12" class="rowCenter">显示</el-col>
          <el-col :span="12" class="rowCenter">
            <el-select v-model="batchShowStatus" placeholder="请选择">
                <el-option
                  v-for="item in batchOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
          </el-col>
        </el-row>
        <el-table :data="batchList" ref="editDataRef" border highlight-current-row class="stockRecovery_table">
          <el-table-column show-overflow-tooltip prop="eightBitCode" label="产品编号">
            <template slot="header">
              <el-button type="text" @click="addBatch">新增</el-button>
            </template>
            <template slot-scope="scope">
              <el-button type="text" style="color:red;" @click="delBatch(scope.row,scope.$index)">删除</el-button>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="eightBitCodeName" label="批次号">
            <template slot-scope="scope">
              <el-input v-model="scope.row.batch"  placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <el-row type="flex" justify="center" style="margin-top:10px;">
        <el-button type="primary" @click="onCancel1">取消</el-button>
        <el-button type="primary" @click="onConfirm1">保存</el-button>
      </el-row>
    </el-dialog> -->


    <el-dialog title="产品名称选择" :visible.sync="dialogProVisible" width="80%" @close="onClosePro">
      <selProDialog @setSelPro="setSelPro"></selProDialog>
    </el-dialog>
  </div>
</template>

<script>
import IcSelect from "@/components/common/icSelect";
import StockRecoveryApi from "@/api/StockRecovery/index";
import commonConstants from "@/constants/commonConstants";
import selProDialog from "./selProName.vue"
import { fileService } from "@/api/common/file-utils";
import store from "@/store";
export default {
  components: {
    IcSelect,
    selProDialog
  },
  data() {
    let validRecoveryProjectSummary = (rule, value, callback) => {
      if (!value) {
        this.$my_message('请输入回收项目简介', 'error')
        callback(new Error(' '));
      } else {
        var reg = /^.{1,100}$/
        if (!reg.test(value)) {
          this.$my_message('字段“回收项目简介”已超出数据库长度要求（长度：100），请删减.', 'error')
          callback(new Error(' '));
        } else {
          callback();
        }
      }
    };
    return {
      closeBtn: false,
      batchList: [],
      batchShowStatus: "",
      activeName: "tab1",
      index: null,
      negativeIndex: -1,
      ttQualityDefectId: this.$route.query.ttQualityDefectId,
      dialogEditVisible: false,
      dialogUploadVisible: false,
      dialogProVisible: false,
      header: {
        'x-access-token': localStorage.getItem('token')
      },
      rules: {
        recoveryStartDate: [
          { required: true, message: '请选择回收启动日期', trigger: 'change' },
        ],
        recoveryProjectSummary: [
          { required: true, validator: validRecoveryProjectSummary, trigger: 'blur' },
        ],
        srGrade: [
          { required: true, message: '请选择SR等级', trigger: 'change' },
        ],
        // reason: [
        //   { required: true, message: '请输入原因', trigger: 'blur' },
        // ]
      },
      uploadForm: {
        attachmentLargeCategory: "",
        attachmentSmallCategory: "",
        fileName: ""
      },
      detailForm: {
        srNumber: "",
        recoveryStartDate: "",
        recoveryProjectSummary: "",
        isClosed: "N",
        srGrade: "A",
        createBy: "",
        status: "Processing",
        reason: "",
        remarks: "",
      },
      batchVisible: false,
      tableData1: [],
      tableData2: [],
      tableData3: [],
      tabData1: [],
      tabData2: [],
      tabData3: [],
      tabData4: [],
      editForm: {
        editData: []
      },
      fileList: [],
      batchOptions: [{
        label: "合并一行显示",
        value: "0",
      }, {
        label: "拆分显示",
        value: "1",
      }],
      isClosedLists: [
        {
          label: "Y",
          value: "Y",
        },
        {
          label: "N",
          value: "N",
        }
      ],
      srGradeLists: [
        {
          label: "A",
          value: "A",
        },
        {
          label: "B",
          value: "B",
        },
        {
          label: "C",
          value: "C",
        },
        {
          label: "D",
          value: "D",
        }
      ],
      relatedDcCodeLists: [],
      attachmentLargeCategoryLists: [],
      attachmentSmallCategoryLists: [],
      multipleSelection: [],
      ttQspiStockRecItemIdLists: [],
    }
  },
  created() {

  },
  watch: {

  },
  filters: {
    dcsFilter(dcIdsStr) {
      var reg = /[;]/g;
      var reg1 = /[' ']/g;
      if (reg.test(dcIdsStr)) {
        console.log("测试数据====", dcIdsStr.split(';').join(' ').replace(reg1, "$&\r\n"))
        // return dcIdsStr = dcIdsStr.replace(reg, "$&\r\n");  // ‘$&’替换与regexp相匹配的子串
        return dcIdsStr = dcIdsStr.split(';').join(' ').replace(reg1, "$&\r\n");  // ‘$&’替换与regexp相匹配的子串

      } else {
        return dcIdsStr
      }
    }
  },
  // filters: {
  //   setRelatedDcCodeI18n(key) {
  //     console.log('key', key);
  //     this.relatedDcCodeLists.for(ele => {
  //       if (ele.dcCode === key) {
  //         return ele.dcName
  //       }
  //     })
  //   },
  // },
  computed: {
    uploadUrl() {
      return commonConstants.fileUploadUrl;
    }
  },
  mounted() {
    this.getDetailInfo()
  },
  methods: {
    getDetailInfo() {
      let ms_userId = localStorage.getItem("ms_userId");

      StockRecoveryApi.qualityDefectDetail(this.ttQualityDefectId).then(res => {
        if (ms_userId == res.data.createBy && res.data.status == 'Inprogress') {
          this.closeBtn = true
        } else {
          this.closeBtn = false
        }
        this.detailForm = res.data
        this.tabData1 = res.data.details
        this.tabData2 = res.data.storeDisposals
        this.tabData3 = res.data.documents
        this.tabData4 = res.data.auditLogList
      });
    },
    getHeaderInfo() {
      StockRecoveryApi.qualityDefectDetail(this.ttQualityDefectId).then(res => {
        this.detailForm = res.data
      });
    },
    getTableInfo() {
      StockRecoveryApi.getItemsByHeaderId(this.ttQualityDefectId).then(res => {
        console.log('res', res);
        this.tableData1 = res.data
        this.$refs.plxTable1.reloadData(res.data)
      });
    },
    handlingResultChange(val, index, editData) {
      var str = []
      if (val.length > 0) {
        val.forEach(ele => {
          str.push(store.state.main.inputChoiceDec['TT_QSPI_STOCK_REC_ITEM']['HANDLING_RESULT'][ele].value)
        })
        editData[index].handlingResult = val
        editData[index].handlingResultI18n = str.join(',')
      }
      console.log('editData', editData);
    },
    getAllAcitveQspiDc() {
      StockRecoveryApi.getAllAcitveQspiDc().then(res => {
        console.log('获取dcs', res);
        this.relatedDcCodeLists = res.data
      });
    },
    getAttachmentsLists() {
      StockRecoveryApi.getAttachmentsByHeaderId(this.ttQualityDefectId).then(res => {
        console.log('获取文件', res);
        this.tableData2 = res.data
      });
    },
    getOperateLogs() {
      StockRecoveryApi.getOperateLogsByHeaderId(this.ttQualityDefectId).then(res => {
        console.log('获取操作日志', res);
        this.tableData3 = res.data
      });
    },
    getAttachLargeCategoryList() {
      StockRecoveryApi.getAttachLargeCategoryList(this.ttQualityDefectId).then(res => {
        console.log('获取附件大类', res);
        this.tableData3 = res.data
      });
    },
    getAttachmentLargeLists() {
      StockRecoveryApi.getAttachLargeCategoryList().then(res => {
        console.log('获取附件大类', res);
        this.attachmentLargeCategoryLists = res.data
      });
    },
    attachmentLargeCategoryChange(val) {
      console.log('val', val);
      this.uploadForm.attachmentSmallCategory = ''
      this.getAttachmentSmallLists(val)
    },
    getAttachmentSmallLists(val) {
      StockRecoveryApi.getAttachSmallCategoryListByLargeCategory(val).then(res => {
        console.log('获取附件小类', res);
        this.attachmentSmallCategoryLists = res.data
        if (val == 'McD’s China internal communication') {
          this.uploadForm.attachmentSmallCategory = 'Stock recovery effective statement'
        }
        if (val == 'DC Stock recovery and return summary') {
          this.uploadForm.attachmentSmallCategory = 'Stock recovery and return summary'
        }
      });
    },
    clickBatch(row) {
      console.log("rowrowrow===", row)
      this.batchVisible = true
    },
    addBatch() {
      this.batchList.push({

      })
    },
    delBatch(row) {

    },
    setSelPro(val) {
      console.log('negativeIndex1111', this.negativeIndex);
      console.log('tableData1', this.tableData1);
      var arr = JSON.parse(val)
      console.log('arr', arr);
      arr.forEach(ele => {
        this.$set(ele, 'ttQspiStockRecItemId', this.negativeIndex)
        this.$set(ele, 'batchNo', '')
        this.$set(ele, 'relatedDcCode', '')
        this.$set(ele, 'relatedDcName', '')
        this.$set(ele, 'regoins', '')
        this.$set(ele, 'recoveryScope', '')
        this.$set(ele, 'recoveryScopeI18n', '')
        this.$set(ele, 'restaurantRecoveryQty', '')
        this.$set(ele, 'dcRecoveryQty', '')
        this.$set(ele, 'recoveryQty', '')
        this.$set(ele, 'handlingResult', [])
        this.$set(ele, 'handlingResultI18n', '')
        this.negativeIndex = this.negativeIndex - 1;
      })
      if (arr.length > 0) {
        for (const i in arr) {
          this.tableData1.push(arr[i])
        }
      }
      console.log('新增后数据', this.tableData1);
      console.log('negativeIndex新增后', this.negativeIndex);
      this.dialogProVisible = false
    },
    // onModify(row, scope) {
    //   // row.handlingResult=
    //   if (row.handlingResult.length > 0) {
    //     this.$set(row, 'handlingResult', row.handlingResult.split(','))
    //   }
    //   this.editForm.editData = []
    //   this.dialogEditVisible = true
    //   this.index = scope.$rowIndex
    //   this.editForm.editData.push(JSON.parse(JSON.stringify(row)))
    //   console.log('this.editForm.editData', this.editForm.editData);
    // },
    // onConfirm() {
    //   console.log('2421', this.editForm.editData);
    //   this.$refs['editForm'].validate((valid) => {
    //     if (valid) {
    //       this.relatedDcCodeLists.forEach(ele => {
    //         if (ele.dcCode == this.editForm.editData[0].relatedDcCode) {
    //           this.editForm.editData[0].relatedDcName = ele.dcName
    //         }
    //       })
    //       this.$refs.plxTable1.reloadRow(this.$refs.plxTable1.data[this.index], this.editForm.editData[0], null)
    //       console.log('this.$refs.plxTable1.data[this.index]', this.$refs.plxTable1.data);
    //       this.dialogEditVisible = false
    //       setTimeout(() => {
    //         this.editForm.editData = []
    //       }, 500);
    //     }
    //   })
    // },
    onUpload() {
      this.dialogUploadVisible = true
      this.uploadForm = {
        attachmentLargeCategory: "",
        attachmentSmallCategory: "",
        fileName: ""
      }
    },
    submitUpload() {
      if (!this.uploadForm.attachmentLargeCategory) {
        this.$my_message('请选择附件大类', 'error');
        return false
      }
      if (!this.uploadForm.attachmentSmallCategory) {
        this.$my_message('请选择附件小类', 'error');
        return false
      }
      this.$refs.upload.submit();
    },
    onCloseFileDialog() {
      this.dialogUploadVisible = false
      this.fileList = []
    },
    closeQualityDefect() {
      StockRecoveryApi.closeQualityDefect(this.ttQualityDefectId).then((res) => {
        if (res.code == 200) {
          this.$message.success('结案成功')
          this.getDetailInfo()
        }
        console.log("rrrrrrrrrr", res)
      })
    },
    beforeUpload(file) {
      const isLt50M = file.size / 1024 / 1024 < 50;
      if (!isLt50M) {
        this.$my_message(this.$t('prompt.imageFileSize'), 'error');
      }
      return isLt50M;
    },
    stinvUrl() {
      window.open(this.detailForm.stinvLink, '_blank');
    },
    uploadSuccess(response, file, fileList) {
      console.log('response', response);
      if (response.code === '200') {
        this.$message.success('上传成功')
        var obj = Object.assign({}, this.uploadForm)
        this.$set(obj, 'uploadBy', response.data[0].uploadBy)
        this.$set(obj, 'uploadTime', response.data[0].uploadTime)
        this.$set(obj, 'fullPath', response.data[0].fullPath)
        this.tableData2.push(obj)
        this.fileList = []
        this.dialogUploadVisible = false
      }
    },
    onDownload(row, index) {
      StockRecoveryApi.downloadFileByFullPath({
        fullPath: row.fullPath,
        documentName: row.fileName
      }).then((res) => {
        console.log('res', res);
        fileService.respToFile(res, row.fileName);
      })
    },
    handleChange(file, fileList) {
      console.log('file', file);
      console.log('fileList', fileList);
      this.uploadForm.fileName = file.name
    },
    delFile(row, index) {
      this.$confirm('是否确认删除此附件', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.tableData2.splice(index, 1)
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    recoveryScopeChange(row, val) {
      console.log('val', val);
      row.recoveryScope = val
      // 当回收范围为DC时，则自动清空且置灰不可编辑
      if (val === "DC") {
        row.restaurantRecoveryQty = ''
      } else if (val === "Restaurant") {
        // 当回收范围为餐厅时，则自动清空且置灰不可编辑
        row.dcRecoveryQty = ''
      }
      if (row.restaurantRecoveryQty && row.dcRecoveryQty) {
        // Number(value).toFixed(2)
        row.recoveryQty = ((((Number(row.restaurantRecoveryQty).toFixed(2)) * 100) + ((Number(row.dcRecoveryQty).toFixed(2)) * 100)) / 100).toFixed(2)
      } else if (row.restaurantRecoveryQty && !row.dcRecoveryQty) {
        row.recoveryQty = Number(row.restaurantRecoveryQty).toFixed(2)
      } else if (!row.restaurantRecoveryQty && row.dcRecoveryQty) {
        row.recoveryQty = Number(row.dcRecoveryQty).toFixed(2)
      } else {
        row.recoveryQty = ''
      }
    },
    // 回收数量(箱)=餐厅回收数量(箱)+DC回收数量(箱)
    dcRecoveryQtyChange(row, val) {
      console.log('row1', row);
      console.log('DC回收数量(箱)', val);
      if (val && row.restaurantRecoveryQty) {
        row.recoveryQty = ((((Number(val).toFixed(2)) * 100) + ((Number(row.restaurantRecoveryQty).toFixed(2)) * 100)) / 100).toFixed(2)
      } else if (val && !row.restaurantRecoveryQty) {
        row.recoveryQty = Number(val).toFixed(2)
      } else if (!val && row.restaurantRecoveryQty) {
        row.recoveryQty = Number(row.restaurantRecoveryQty).toFixed(2)
      } else {
        row.recoveryQty = ''
      }
    },
    restaurantRecoveryQtyChange(row, val) {
      console.log('row2', row);
      console.log('餐厅回收数量(箱)', val);
      if (val && row.dcRecoveryQty) {
        row.recoveryQty = ((((Number(val).toFixed(2)) * 100) + ((Number(row.dcRecoveryQty).toFixed(2)) * 100)) / 100).toFixed(2)
      } else if (val && !row.dcRecoveryQty) {
        row.recoveryQty = Number(val).toFixed(2)
      } else if (!val && row.dcRecoveryQty) {
        row.recoveryQty = Number(row.dcRecoveryQty).toFixed(2)
      } else {
        row.recoveryQty = ''
      }
    },
    onAdd() {
      this.dialogProVisible = true
    },
    // 选中的行
    selectionChange(row) {
      console.log(row)
      this.multipleSelection = row
      this.ttQspiStockRecItemIdLists = []
      row.forEach(ele => {
        this.ttQspiStockRecItemIdLists.push(ele.ttQspiStockRecItemId)
      })
    },
    onCopy() {
      if (this.multipleSelection.length == 0) {
        this.$my_message('请选择操作数据', 'error')
        return false
      }
      console.log('negativeIndex', this.negativeIndex);
      this.multipleSelection.forEach((ele, index) => {
        this.tableData1.splice(index, 0, JSON.parse(JSON.stringify(ele)))
      });
      this.tableData1.forEach(ele => {
        this.$set(ele, 'ttQspiStockRecItemId', this.negativeIndex)
        this.negativeIndex = this.negativeIndex - 1;
      })
      this.$refs.plxTable1.clearSelection();
      console.log('negativeIndex复制后', this.negativeIndex);
    },
    onDel() {
      if (this.multipleSelection.length == 0) {
        this.$my_message('请选择操作数据', 'error');
        return false
      }
      //您确定要删除所选记录吗？
      this.$confirm('您确定要删除所选记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'colorBtn',
        cancelButtonClass: 'btn_custom_cancel',
        type: 'warning'
      }).then(() => {
        console.log('this.tableData1', this.tableData1);
        console.log('this.ttQspiStockRecItemIdLists', this.ttQspiStockRecItemIdLists);
        var length = this.tableData1.length
        for (let i = length - 1; i >= 0; i--) {
          const ele = this.tableData1[i];
          if (this.ttQspiStockRecItemIdLists.includes(ele.ttQspiStockRecItemId)) {
            this.tableData1.splice(i, 1);
          }
        }
      })
    },
    renderHeader(h, { column, $index }) {
      return h("span", [
        h("span", { class: "mandatory" }),
        h("span", column.label)
      ]);
    },
    onSubmit(type) {
      this.$refs['detailForm'].validate((valid) => {
        if (valid) {
          if (this.tableData1.length == 0) {
            this.$my_message('请至少填写一行产品明细', 'error')
            return false
          }
          let flag = false;
          for (let i = 0; i < this.tableData1.length; i++) {
            const ele = this.tableData1[i];
            if (!ele.batchNo) {
              this.$my_message('第' + (i + 1) + '行,产品批次必填', 'error')
              flag = true
            }
            if (!ele.recoveryScope) {
              this.$my_message('第' + (i + 1) + '行,回收范围必填', 'error')
              flag = true
            }
            if (!ele.handlingResult) {
              this.$my_message('第' + (i + 1) + '行,处理结果必填', 'error')
              flag = true
            }
            // 当回收范围为餐厅或DC+餐厅时 餐厅回收数量必填 
            if ((ele.recoveryScope === "DCAndRestaurant" || ele.recoveryScope === "Restaurant") && !ele.restaurantRecoveryQty) {
              this.$my_message('第' + (i + 1) + '行,餐厅回收数量必填', 'error')
              flag = true
            }
            // 当回收范围为DC或DC+餐厅时 DC回收数量必填
            if ((ele.recoveryScope === "DCAndRestaurant" || ele.recoveryScope === "DC") && !ele.dcRecoveryQty) {
              this.$my_message('第' + (i + 1) + '行,DC回收数量必填', 'error')
              flag = true
            }
            var reg = /^[0-9]+(\.[0-9]{1,3})?$/
            if (ele.restaurantRecoveryQty && !reg.test(ele.restaurantRecoveryQty)) {
              this.$my_message('第' + (i + 1) + '行,字段“餐厅回收数量”输入格式不满足要求（格式：数字,最多两位小数），请检查.', 'error')
              flag = true
            }
            if (ele.dcRecoveryQty && !reg.test(ele.dcRecoveryQty)) {
              this.$my_message('第' + (i + 1) + '行,字段“DC回收数量”输入格式不满足要求（格式：数字,最多两位小数），请检查.', 'error')
              flag = true
            }
          }
          if (flag) {
            return;
          }
          console.log('this.tableData1', this.tableData1);
          this.tableData1.forEach(ele => {
            if ((typeof ele.handlingResult == 'object') && ele.handlingResult.constructor == Array) {
              this.$set(ele, 'handlingResult', ele.handlingResult.join(','))
            }
          })
          console.log('this.333', this.tableData1);
          var obj = {
            ttQualityDefectId: this.ttQualityDefectId,
            recoveryStartDate: this.detailForm.recoveryStartDate,
            recoveryProjectSummary: this.detailForm.recoveryProjectSummary,
            srGrade: this.detailForm.srGrade,
            remarks: this.detailForm.remarks,
            reason: this.detailForm.reason,
            items: this.tableData1,
            attachments: this.tableData2
          }
          if (type === 'close') {
            StockRecoveryApi.close(obj).then(res => {
              console.log('res', res);
              if (res.code === '200') {
                this.$message.success('结案成功')
                this.$router.go(-1)
              }
            });
          }
          if (type === 'submit') {
            StockRecoveryApi.submitStockRecovery(obj).then(res => {
              console.log('res', res);
              if (res.code === '200') {
                this.$message.success('提交成功')
                this.$router.go(-1)
              }
            });
          }
        }
      })
    },
    restaurantRecoveryQtyRules(index, row) {
      return (this.rules["restaurantRecoveryQty"] = [
        {
          validator: (rule, value, callback) => {
            if (value) {
              var reg = /^[0-9]+(\.[0-9]{1,3})?$/
              if (!reg.test(value)) {
                this.$my_message('字段“餐厅回收数量”输入格式不满足要求（格式：数字,最多两位小数），请检查.', 'error')
                return callback(new Error(' '));
              }
              value = Number(value).toFixed(2)
              this.editForm.editData[index].restaurantRecoveryQty = value
            }
            callback();
          },
          trigger: "blur"
        }
      ]);
    },
    dcRecoveryQtyRules(index, row) {
      return (this.rules["dcRecoveryQty"] = [
        {
          validator: (rule, value, callback) => {
            if (value) {
              var reg = /^[0-9]+(\.[0-9]{1,2})?$/
              if (!reg.test(value)) {
                this.$my_message('字段“DC回收数量”输入格式不满足要求（格式：数字,最多两位小数），请检查.', 'error')
                return callback(new Error(' '));
              }
              value = Number(value).toFixed(2)
              this.editForm.editData[index].dcRecoveryQty = value
            }
            callback();
          },
          trigger: "blur"
        }
      ]);
    },
    onCancel() {
      this.dialogEditVisible = false
      this.editForm.editData = []
    },
    onCancel1() {
      this.batchVisible = false
    },
    onConfirm1() {
      console.log("dddddddddddddd")
    },
    onClose() {
      this.dialogUploadVisible = false
    },
    onClosePro() {
      this.dialogProVisible = false
    },
    routerBack() {
      this.$router.go(-1)
    },
  },
}
</script>

<style scoped>
/deep/ .setLength table tbody tr td .newDcs {
  white-space: pre-line !important;
}

.stockRecovery_table .el-form-item {
  margin-bottom: 0 !important;
}

.rowCenter {
  display: flex;
  justify-content: center;
  align-content: center;
}
</style>